export default __webpack_public_path__ + "static/media/forestry.87b74dbe.svg";